module.exports = __webpack_public_path__ + "img/Mask_Group_4.84c84741.png";